import { CommonModule } from '@angular/common';
import { Component, Input,  OnChanges,  OnInit,  forwardRef } from '@angular/core';
import {  ControlValueAccessor,  FormsModule,  NG_VALUE_ACCESSOR, ReactiveFormsModule} from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgSelectModule } from '@ng-select/ng-select';
@Component({
    standalone: true,
    selector: 'app-ng-select-with-select-all',
    templateUrl: './ng-select-with-select-all.component.html',
    styleUrls: ['./ng-select-with-select-all.component.scss'],
    providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NgSelectWithSelectAllComponent),
      multi: true
    }],
    imports: [ MatCheckboxModule, FormsModule, ReactiveFormsModule, CommonModule, NgSelectModule]
})
export class NgSelectWithSelectAllComponent implements ControlValueAccessor , OnInit, OnChanges {
   
    // Declaration of an empty array to store all items
    @Input() allItems: any[] = [];
    // Declaration of a string variable to store the placeholder text
    @Input() textFieldName: string = ""; // Default text field name
    // Declaration of a string variable to store the value field name
    @Input() valueFieldName: string = ""; // Default value field name
    // Declaration of a string variable to store the group field name
    @Input() groupFieldName: string = ""; // Default value field name
     // Declaration of an empty array to store selected items
    @Input() required: boolean = false; // Default value for required
    @Input() placeholder: string = "Select"; // Default placeholder text
    value: any[] = [];
      groupExpeansion: {} = {};
    onChange = (_: any) => {};
    onTouched = () => {};
    // Declaration of a boolean variable to store the value of isAllSelected
    isAllSelected: boolean = false;
    isIndeterminate: boolean = false;
    constructor() {
        // This is intentional
    }

    ngOnInit() {
        this.initialize();
    }
    ngOnChanges(changes) {
        if (changes.allItems) {
            if (changes.allItems.currentValue) {
                this.initialize();
            }
            this.isAllSelected = false;
            this.value = [];
            this.onChange(this.value);
            this.onTouched();
        }
    }
    private initialize() {
        this.allItems.forEach(item => {
            if (this.groupFieldName) {
                const groupName = item[this.groupFieldName];
                if (!this.groupExpeansion.hasOwnProperty(groupName)) {
                    this.groupExpeansion[groupName] = false;
                }
            }
        });
    }

    writeValue(val: any): void {
        this.value = val || [];
    }
     registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    // Method to toggle the selection of all items
    toggleSelectAll() {
        if (!this.isAllSelected) {
            this.value = [];
        } else {
            this.value = this.allItems.map(item => item[this.valueFieldName]);
        }
        this.onChange(this.value);
        this.onTouched();
    }
    // Method to check if all items are selected
    onSelectionChange() {
        this.isAllSelected = this.value.length === this.allItems.length && this.allItems.length > 0 && this.allItems.every(account=> this.value.includes(account[this.valueFieldName]));
        this.isIndeterminate = this.value.length > 0 && !this.isAllSelected;
        this.onChange(this.value);
        this.onTouched();
    }
    selectUnselectGroup(item: any, selected: boolean) {
        const children = this.allItems.filter(a => a[this.groupFieldName] === item[this.groupFieldName]).map(x=> x[this.valueFieldName]);
        if(selected) {
            const newSelection = children.filter(child => !this.value.includes(child));
            this.value = [...this.value, ...newSelection];
        }else{
            this.value = this.value.filter(child => !children.includes(child));
        }
        this.onSelectionChange();
        this.onChange(this.value);
        this.onTouched();
    }
    isIndetermediateGroup(group){
        const children = this.allItems.filter(a => a[this.groupFieldName] === group).map(x=> x[this.valueFieldName]);
        return children.some(child => this.value.includes(child)) && !children.every(child => this.value.includes(child));
    }
    isAllSelectedGroup(group){
        const children = this.allItems.filter(a => a[this.groupFieldName] === group).map(x=> x[this.valueFieldName]);
        return children.every(child => this.value.includes(child));
    }
    toggleGroup(group){
        const groupObj = this.groupExpeansion.hasOwnProperty( group);
        if (groupObj) {
            this.groupExpeansion[group] = !this.groupExpeansion[group];
        } 
    }

    noop() {} // This is intentional 
}
